import DOMPurify from 'dompurify';

/**
 * Sanitize an HTML string before rendering with dangerouslySetInnerHTML.
 * Allows the rich-text formatting produced by the TipTap editor while
 * stripping scripts, event handlers and other XSS vectors.
 */
export function sanitizeHtml(html) {
    if (!html) return '';
    return DOMPurify.sanitize(html, {
        USE_PROFILES: { html: true },
        ADD_ATTR: ['target', 'rel'],
        FORBID_TAGS: ['style', 'script', 'iframe', 'object', 'embed', 'form'],
        FORBID_ATTR: ['onerror', 'onload', 'onclick', 'style'],
    });
}
